// Filigrane du PDF (configuration.watermark). Le service PDF le dessine à la
// fusion des pages (pdf/pdfGen/watermark.js) ; l'éditeur le montre dans ses
// aperçus avec les mêmes règles.

// Police du PDF quand aucune n'est choisie, et ses équivalents à l'écran.
export const WATERMARK_DEFAULT_FONT = 'Helvetica, Arial, sans-serif';

// Réglé sur « valeurs manquantes », le filigrane disparaît une fois le
// formulaire complet (plus de point d'exclamation). `formIncomplete` n'est
// connu que pour une proposition : en modèle, il se montre toujours.
const isHiddenByCompleteForm = (watermark, formIncomplete) =>
  watermark?.display === 'missingValues' && formIncomplete === false;

export const isWatermarkShown = (watermark, { formIncomplete } = {}) =>
  !!watermark?.enabled &&
  typeof watermark.text === 'string' &&
  !!watermark.text.trim() &&
  !isHiddenByCompleteForm(watermark, formIncomplete);

// Les pages pleine page (couverture, séparateurs, PDF importés en pleine page)
// peuvent en être exclues.
export const isWatermarkOnPage = (watermark, { isFullHeight, formIncomplete }) =>
  isWatermarkShown(watermark, { formIncomplete }) &&
  !(isFullHeight && watermark.pages === 'content');

// Angle de la diagonale, du bas à gauche vers le haut à droite, en degrés.
export const watermarkAngle = ({ width, height }) =>
  (Math.atan2(height, width) * 180) / Math.PI;

// Configuration envoyée au service PDF : le PDF archivé, version officielle,
// peut se passer du filigrane, comme celui d'un formulaire complet.
export const withWatermarkForExport = (
  configuration,
  type,
  { formIncomplete } = {}
) => {
  const { watermark } = configuration;
  const hidden =
    (type === 'archive' && watermark?.hideOnArchive) ||
    isHiddenByCompleteForm(watermark, formIncomplete);
  if (!hidden) return configuration;
  return {
    ...configuration,
    watermark: { ...configuration.watermark, enabled: false },
  };
};
